export default {
  home: {
    reservation_filters: "Reservation filters",
    ongoing_reservations: "Ongoing reservations",
    future_reservations: "Future reservations",
    open_balance: "Open balance",
    past_reservations: "Past reservations",
    reference_number: "Reference number",
    check_in: "Check-in",
    check_out: "Check-out",
    nights: "Nights",
    to_pay_today: "To pay today",
    cancelled: "CANCELLED",
    pay_my_reservation: "PAY MY RESERVATION",
    extend_my_reservation: "EXTEND MY RESERVATION",
    rooms: "Rooms",
    contract_id: "Contract ID",
    arrival: "Arrival",
    departure: "Departure",
    guests: "Guests",
    unit_type: "Unit Type",
    main_guest: "Main guest",
    fetching_reservations: "Fetching reservations",
    offer_awaiting_reply: "offer awaiting reply",
    offers_awaiting_reply: "offers awaiting reply"
  },
  extend: {
    find_availabilities: "Find availabilities",

    select_contracts_extend: "Select Contracts to Extend",
    select_all: "Select All",
    deselect_all: "Deselect All",

    id: "ID",
    stay: "Stay",
    unit: "Room",
    guest: "Guest",

    pick_new_departure: "Pick a new departure date",
    extend_for_price: "Extend your stay at this room for ",
    extend_for: "Extend for ",
    days: "days",

    pick_options: "Pick your options",
    previous_contract: "Previous contract",
    next_contract: "Next contract",

    reservation_overview: "Reservation overview",
    total_balance: "Total balance",
    confirm_extension: "I confirm my extension by clicking proceed to payment",
    proceed_to_payment: "Proceed to payment",
    go_to_overview: "Go to overview",
    previous_balance: "Previous balance",
    balance_after_extension: "Balance after extension"
  },
  offer: {
    offer_summary: "Offer Summary",
    prices_calculated_30_days: "Prices below are calculated for the first 30 days",
    description: "Description",
    price: "Price",
    book_my_offer: "Book my offer",
    total: "Total",
    total_first_month: "Total first month",
    from: "From",
    month: "month",
    accept: "Accept",
    decline: "Decline",
    action_required: "Action required",
    one_time_costs: "One-time costs",
    offer_not_booked_yet: "Offer not booked yet.",
    enter_details: "Please enter details to book the offer.",
    complete_guest_details: "Please complete all guest details and room preferences before booking your stay.",
    guest_for: "Guest for",
    options_for: "Options for",
    confirm_options_flat: "Confirm options for this flat",
    loading_options: "Loading options",
    previous_flat: "Previous Flat",
    next_flat: "Next Flat",
    cannot_proceed_max_flats: "You have reached the maximum number of flats.",
    cannot_proceed_guest_info_invalid: "Please complete all guest information before proceeding.",
    cannot_proceed_options_not_confirmed: "Please confirm your selected options before proceeding.",
    apartment: "Apartment",
    persons: "persons"

  },
  error: {
    no_availabilities: "No availabilities found for this date. Please select another date or contact our sales team.",
    extend_success: "Reservation succesfully extended.",
    extend_failed: "Failed to extend reservation. Please contact our sales team."
  }
}
